var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 16.9313C3.375 13.8671 3.375 12.3351 4.3269 11.3832C5.27881 10.4313 6.81087 10.4313 9.875 10.4313H26.125C29.1891 10.4313 30.7212 10.4313 31.6731 11.3832C32.625 12.3351 32.625 13.8671 32.625 16.9313V23.4313C32.625 26.4954 32.625 28.0275 31.6731 28.9794C30.7212 29.9313 29.1891 29.9313 26.125 29.9313H9.875C6.81087 29.9313 5.27881 29.9313 4.3269 28.9794C3.375 28.0275 3.375 26.4954 3.375 23.4313V16.9313Z",
    stroke: "#707070",
    strokeWidth: 2.16938
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 10.4297L27.0009 8.68171C26.182 6.77105 25.7726 5.81572 24.9586 5.27895C24.1445 4.74219 23.1052 4.74219 21.0264 4.74219H9.875C6.81087 4.74219 5.27881 4.74219 4.3269 5.69409C3.375 6.64599 3.375 8.17806 3.375 11.2422V21.8047",
    stroke: "#707070",
    strokeWidth: 2.16938
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.3125,
    y: 15.3063,
    width: 3.25,
    height: 3.25,
    rx: 1.625,
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaye);
export default __webpack_public_path__ + "static/media/paye.df67b600febff580ca4d009324f5d3cf.svg";
export { ForwardRef as ReactComponent };